import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";
import { postTags, updateTags } from "./tags";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  banners: [],
  singleBanner: {},
  fetchLoading: false,
};

const slice = createSlice({
  name: "banners",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // FETCH  LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.fetchLoading = false;
    },

    // TODO: success post blog

    postBannersuccess(state, action) {
      state.isLoading = false;
      // state.banners = [action.payload, ...state.banners.data];
      // state.banners.meta.total += 1;
    },
    // TODO: successFetch blog

    getBannersuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.banners = action.payload;
    },

    // TODO: single blog fetch success

    getSingleBannersucess(state, action) {
      state.isLoading = false;
      state.singleBanner = action.payload;
    },

    // Update blog
    updateBannersuccess(state, action) {
      state.isLoading = false;
      // state.banners.data = state.banners.data.map((banner) => {
      //   if (banner.slug === action.payload.slug) {
      //     return action.payload;
      //   } else {
      //     return banner;
      //   }
      // });
    },

    // delete blog
    deleteBannersuccess(state, action) {
      state.isLoading = false;
      // state.banners.data = state.banners.data.filter(
      //   (banner) => banner.id !== action.payload
      // );
      // state.banners.meta.total -= 1;
    },
  },
});

export default slice.reducer;

export function getBanners({ categoryId, limit = 5, page = 0, season_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`items`, {
        params: {
          limit,
          page: page + 1,
          category_slug: categoryId,
          season_id,
        },
      });

      dispatch(
        slice.actions.getBannersuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateBanner({ slug, data, tagData, enqueueSnackbar, tag_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items/${slug}`, data);
      if (
        tagData?.team ||
        tagData?.player ||
        tagData?.game ||
        tagData?.category
      ) {
        if (tag_id) {
          dispatch(
            updateTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
              tag_id,
            })
          );
        } else {
          dispatch(
            postTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
            })
          );
        }
      }

      dispatch(slice.actions.updateBannersuccess(response.data.data));
      enqueueSnackbar("Banner is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postBanner({ data, enqueueSnackbar, tagData, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items`, data);

      dispatch(
        postTags({
          tagData: { ...tagData, item_id: response.data.data.id },
          enqueueSnackbar,
        })
      );

      dispatch(
        postTags({
          tagData: { ...tagData, item_id: response.data.data.id },
          enqueueSnackbar,
        })
      );
      dispatch(slice.actions.postBannersuccess(response.data.data));
      enqueueSnackbar("Banner is created successfully");
      navigate(PATH_DASHBOARD.banner.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBanner(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`items/${id}`);

      dispatch(slice.actions.getSingleBannersucess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteBanner({
  id,
  enqueueSnackbar,
  categoryId,
  pagination,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`items/${id}`);
      dispatch(slice.actions.deleteBannersuccess(id));
      dispatch(
        getBanners({
          categoryId,
          page: pagination.page,
          limit: pagination.limit,
          season_id,
        })
      );
      enqueueSnackbar("Banner is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
